import { render, staticRenderFns } from "./personaliInfo.vue?vue&type=template&id=0f0219a1&scoped=true"
import script from "./personaliInfo.vue?vue&type=script&lang=js"
export * from "./personaliInfo.vue?vue&type=script&lang=js"
import style0 from "./personaliInfo.vue?vue&type=style&index=0&id=0f0219a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0219a1",
  null
  
)

export default component.exports